export const SALES_PERFORMANCE_METRICS: Record<string, string> = {
  contributionProfit: "Contribution Profit",
  ntbSales: "NTB Sales",
  subscriptionSales: "Subscription Sales",
  totalAdSales: "Total Ad Sales",
  totalAdSpend: "Total Ad Spend",
  totalSales: "Total Sales",
};
